const styles = theme => ({
  mainContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '100vh',
    flexDirection: 'column',
    fontFamily: 'Titillium-Regular, Helvetica Neue, sans-serif',
    fontSize: '14px'
  },
  // header start from here
  header: {
    backgroundColor: '#ea4367',
    color: '#fff',
    height: '60px',
    width: '100%'
  },
  headerContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    height: '60px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 15px'
  },
  circle: {
    height: '25px',
    width: '25px',
    backgroundColor: '#fde6e6',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
    fontSize: '10px',
    color: '#cb2a49',
    marginRight: '7px'
  },
  brandImage: {
    height: '36px'
  },
  dropdownMenu: {
    display: 'flex',
    alignItems: 'center'
  },
  // header end here

  profileContainer: {
    padding: '19px 28px 27px',
    margin: '0 auto',
    width: '100%',
    maxWidth: '549px',
    color: '#323233',
    borderRadius: '2px',
    boxShadow: '0 13px 34px 0 rgba(88, 99, 125, 0.1)'
  },
  profileHeading: {
    fontSize: '26px',
    fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
    marginBottom: '15px'
  },
  profileSubHeading: {
    fontSize: '14px',
    fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
    textTransform: 'uppercase',
    marginTop: '30px'
  },
  editProfileButton: {
    fontSize: '14px',
    fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
    textTransform: 'uppercase',
    width: '165px',
    height: '40px',
    marginTop: '30px'
  },
  profileTextField: {
    width: '90%'
  },
  footerText: {
    margin: 'auto auto 20px',
    fontSize: '13px',
    color: '#58637d'
  }

})
export default styles
